
function MasterLandingPage() {

    return (
        <>
            <div className='banner_bg'>
            </div>
        </>
    );
}

export default MasterLandingPage;